import { Menu, MenuProps } from 'antd'
import { FC } from 'react'
import { obtenerIcono } from '../util/AppIcons'
import { IUsuarioByEmail } from '../../model/userMenu';

type MenuItem = Required<MenuProps>['items'][number];

export const MenuLateral: FC<{ handleClick: Function, menu: IUsuarioByEmail, selectedMenu: any }> = (props) => {
  const _menu = props.menu.rol.menuTree

  const getItem = (
    label: React.ReactNode,
    key: React.Key,
    url: string,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'
  ) : MenuItem => {
    return {
      key,
      icon,
      children,
      label,
      onClick: ()=>props.handleClick(url,label),
      type,
    } as MenuItem;
  }

  const items: MenuItem[] = _menu.map( ({ nombre, url, icono, submenus }) => {
    const labelName = nombre.replace('NotMF','')
    const getItemSubMenus = submenus?.map(({ nombre, url, icono }) =>
      getItem(labelName, `${nombre}${url}`, url, obtenerIcono(icono?.toLowerCase()) )
    )
    const subMenuOrUndefined =  getItemSubMenus.length > 0 ? getItemSubMenus : undefined
    return getItem(labelName, `${nombre}${url}`, url, obtenerIcono(icono?.toLowerCase()), subMenuOrUndefined)
  })

  return (
    <Menu
      theme="light"
      selectedKeys={props.selectedMenu}
      mode="inline"
      key={"MenuLateralIzq"}
      items={items}
    />
  )
}